module.exports = __webpack_public_path__ + "img/step_second_white.65452dc2.svg";